export const LUCKY = '☘'
